module.exports = __webpack_public_path__ + "media/images/partner-alt-3-16c8727372dbf23de33edf5eede0e667.png";